/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'New Note',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            d="M2.71328 2.68745C2.71328 2.61151 2.77484 2.54995 2.85078 2.54995H10.0204C10.3242 2.54995 10.5704 2.30371 10.5704 1.99995C10.5704 1.69619 10.3242 1.44995 10.0204 1.44995H2.85078C2.16733 1.44995 1.61328 2.004 1.61328 2.68745V13.3125C1.61328 13.9959 2.16733 14.55 2.85078 14.55H12.4758C13.1592 14.55 13.7133 13.9959 13.7133 13.3125V8.66662C13.7133 8.36286 13.467 8.11662 13.1633 8.11662C12.8595 8.11662 12.6133 8.36286 12.6133 8.66662V13.3125C12.6133 13.3884 12.5517 13.45 12.4758 13.45H2.85078C2.77484 13.45 2.71328 13.3884 2.71328 13.3125V2.68745Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8566 2.95748C13.15 2.25081 12.0042 2.25081 11.2976 2.95748L6.5946 7.66045C6.43529 7.81975 6.31737 8.0156 6.25112 8.23093L5.52017 10.6065C5.46026 10.8012 5.51289 11.0131 5.65694 11.1572C5.801 11.3012 6.01288 11.3539 6.2076 11.2939L8.58318 10.563C8.79851 10.4967 8.99436 10.3788 9.15367 10.2195L13.8566 5.51655C14.5633 4.80988 14.5633 3.66414 13.8566 2.95748ZM12.0754 3.7353C12.3525 3.45821 12.8017 3.45821 13.0788 3.7353C13.3559 4.01239 13.3559 4.46164 13.0788 4.73873L12.9729 4.84461L11.9695 3.84118L12.0754 3.7353ZM11.1917 4.619L12.1951 5.62243L8.37585 9.4417C8.34341 9.47413 8.30353 9.49814 8.25969 9.51163L6.87705 9.93706L7.30248 8.55443C7.31597 8.51058 7.33998 8.4707 7.37242 8.43826L11.1917 4.619Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M5.59746 4.00002C5.59746 3.77911 5.77655 3.60002 5.99746 3.60002H14.9975C15.3288 3.60002 15.5975 3.3314 15.5975 3.00002C15.5975 2.66865 15.3288 2.40002 14.9975 2.40002H5.99746C5.1138 2.40002 4.39746 3.11637 4.39746 4.00002V20C4.39746 20.8837 5.11381 21.6 5.99746 21.6H17.9975C18.8811 21.6 19.5975 20.8837 19.5975 20V13C19.5975 12.6687 19.3288 12.4 18.9975 12.4C18.6661 12.4 18.3975 12.6687 18.3975 13V20C18.3975 20.2209 18.2184 20.4 17.9975 20.4H5.99746C5.77655 20.4 5.59746 20.2209 5.59746 20V4.00002Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.4831 4.47137C19.657 3.64532 18.3177 3.64532 17.4917 4.47137L11.834 10.1291C11.6494 10.3136 11.5128 10.5405 11.4361 10.7899L10.5568 13.6478C10.4914 13.8602 10.5488 14.0913 10.706 14.2485C10.8631 14.4056 11.0943 14.463 11.3067 14.3977L14.1645 13.5183C14.414 13.4416 14.6408 13.305 14.8254 13.1205L20.4831 7.46276C21.3091 6.63671 21.3091 5.29742 20.4831 4.47137ZM18.3402 5.3199C18.6976 4.96248 19.2771 4.96248 19.6345 5.3199C19.992 5.67732 19.992 6.25681 19.6345 6.61423L19.4636 6.7852L18.1692 5.49087L18.3402 5.3199ZM17.3207 6.3394L18.615 7.63373L13.9768 12.2719C13.9307 12.3181 13.874 12.3522 13.8116 12.3714L12.037 12.9174L12.583 11.1428C12.6022 11.0805 12.6364 11.0237 12.6825 10.9776L17.3207 6.3394Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
